import { Box } from '@factorialco/deprecated-design-system'
import { uniqBy } from 'lodash'

import IncidenceDetailDataChangeLine from 'modules/bookkeepers/components/IncidenceDetailDataChangeLine'
import { CostCenter, costCenterPercentageToString } from 'modules/payroll_bundle/lib/costCenters'

interface DataChangeInfoProps {
  costCenters: CostCenter[]
}

export const CostCenterChangeInfo = ({ costCenters }: DataChangeInfoProps) => {
  const previousCostCenters: Map<number, CostCenter> = new Map()
  const currentCostCenters: Map<number, CostCenter> = new Map()
  costCenters.forEach((costCenter) => {
    if (costCenter.end_date) {
      previousCostCenters.set(costCenter.cost_center_id, costCenter)
    } else {
      currentCostCenters.set(costCenter.cost_center_id, costCenter)
    }
  })
  const filteredCostCenters = uniqBy(costCenters, 'cost_center_id')

  return (
    <>
      {filteredCostCenters.map((costCenter) => {
        const currentCostCenter = currentCostCenters.get(costCenter.cost_center_id)
        const previousCostCenter = previousCostCenters.get(costCenter.cost_center_id)
        if (currentCostCenter?.percentage === previousCostCenter?.percentage) {
          return null
        }

        return (
          <Box gap="s16" key={`cost_center_change_${costCenter.id}`}>
            <IncidenceDetailDataChangeLine
              label={costCenter.cost_center}
              oldValue={costCenterPercentageToString(previousCostCenter)}
              newValue={costCenterPercentageToString(currentCostCenter)}
            />
          </Box>
        )
      })}
    </>
  )
}
